module.exports = __webpack_public_path__ + "img/224.electric_problem.e9d0d07c.svg";